import { CaretRight } from "@phosphor-icons/react";
import { useMemo, useState } from "react";

import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";

import MobileListTable from "../../MobileListTable";
import MobilePreview from "./MobilePreview";

import type { ColumnDef } from "@tanstack/react-table";
import type { Webhook } from "../../../types";

interface TableProps {
  webhooks: Webhook[];
}

export default function MobileList({ webhooks }: TableProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedWebhookId, setSelectedWebhookId] = useState<string>(null);

  const selectedWebhook =
    selectedWebhookId && webhooks.find(({ id }) => id === selectedWebhookId);

  function onRowClick(webhook: Webhook) {
    setSelectedWebhookId(webhook.id);
    setIsOpen(true);
  }

  const columns: ColumnDef<Webhook>[] = useMemo(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: "Name",
        cell: ({ row: { original } }) => (
          <span className="line-clamp-1 break-all text-sm-bold">
            {original.name}
          </span>
        ),
      },
      {
        id: "events",
        accessorKey: "events",
        header: "Events",
        cell: ({
          row: {
            original: { events },
          },
        }) => (
          <span className="line-clamp-1 text-button-xs">
            {events.length === 1
              ? events[0]
              : `${events[0]} (+ ${events.length - 1} more)`}
          </span>
        ),
      },
      {
        id: "actions",
        cell: () => (
          <Button intent="labelIcon" size="sm" variant="ghost-black">
            <CaretRight />
          </Button>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <MobileListTable
        columns={columns}
        data={webhooks}
        onRowClick={onRowClick}
        isLoading={false}
      />

      <RenderIf condition={!!selectedWebhook}>
        <MobilePreview
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          webhook={selectedWebhook}
        />
      </RenderIf>
    </>
  );
}
